import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: 24px;\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: 30px;\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-height: 80vh;\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: ", ";\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tbox-shadow: none;\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t&:first-of-type {\n\t\tborder-top-left-radius: ", ";\n\t\tborder-top-right-radius: ", ";\n\t}\n\n\t&:last-of-type {\n\t\tborder-bottom-left-radius: ", ";\n\t\tborder-bottom-right-radius: ", ";\n\t}\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\tmin-height: ", ";\n\tpadding-bottom: ", ";\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n\tpadding-top: ", ";\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: calc(", " * -1);\n\tmargin-right: calc(", " * -1);\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: auto;\n\tmax-height: 100%;\n\tpadding: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 100%;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-bottom: 1px solid;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbox-shadow: 0 0 0 1px ", ";\n\toutline: none;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Card = css(_templateObject(), ui.get('surfaceBorderColor'));
export var Header = css(_templateObject2());
export var Content = css(_templateObject3());
export var Body = css(_templateObject4(), ui.get('cardPadding'));
export var InnerBody = css(_templateObject5(), ui.get('cardPadding'), ui.get('cardPadding'));
export var headerFooter = css(_templateObject6(), ui.get('colorDivider'), ui.get('cardHeaderHeight'), ui.get('cardHeaderFooterPaddingY'), ui.get('cardPaddingX'), ui.get('cardPaddingX'), ui.get('cardHeaderFooterPaddingY'));
export var borderRadius = css(_templateObject7(), ui.get('cardBorderRadius'), ui.get('cardBorderRadius'), ui.get('cardBorderRadius'), ui.get('cardBorderRadius'));
export var borderless = css(_templateObject8());
export var rounded = css(_templateObject9(), ui.get('cardBorderRadius'));
export var popoverBody = css(_templateObject10());
export var small = css(_templateObject11());
export var xSmall = css(_templateObject12());